// Global overlay components mounted at the root layout level.
import { tenant } from '@/tenants/tenant'
import { OnboardingDrawer } from './onboarding-drawer'

export const GlobalDrawers = () => {
	// The full-screen onboarding flow lives in /onboarding/* routes. The legacy
	// small modal carousel is only mounted for tenants configured to use it.
	if (tenant.features.onboarding.style === 'carousel') {
		return <OnboardingDrawer />
	}
	return null
}
